import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto,Alert } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:재고 답변
 * 세부설명:
*/

export class StockQst extends Component {
    static displayName = StockQst.name;

    constructor(props) {
        super(props);
        this.state = {
            MasterData:[],
            GoodsList:[],
            Content:"",
            isOk:false

        };
        this.PageComplete = false;
        this.CsName = Big3Common.ContentState;
        this.QstStatus=Big3Common.Util.GetContentState(this.props.ContentState,this.CsName.QstStatus,"");
        this.QstgrpNo=Big3Common.Util.GetContentState(this.props.ContentState,this.CsName.QstgrpNo,"");
        this.Union_Uid=Big3Common.Util.GetContentState(this.props.ContentState,this.CsName.Union_Uid,"");

        this.handleBuyYn_Click=this.handleBuyYn_Click.bind(this);
        this.handleQuanAdd_Change=this.handleQuanAdd_Change.bind(this);
        this.handleSave_Click=this.handleSave_Click.bind(this);
        this.handleBack_Clik=this.handleBack_Clik.bind(this);
    }
    //초기화
    async componentDidMount() {
        await this.CallQstMgtlGoodsListData();
    }
    //주문문의 조회(마스터+상태+코멘트 내역)
    async CallQstMgtlGoodsListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Model = {
                Qstgrp_No:this.QstgrpNo,
                Union_Uid: this.Union_Uid,
                Qst_Status:this.QstStatus
            }
            let Data = await Big3Common.Post('api/Order/QuestionMgr/GetQstMgtlGoodsList',Model,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const CallList = JSON.parse(Data.multiDataTable);
                this.setState({
                    MasterData: CallList.Master,
                    GoodsList: CallList.GoodsList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstMgtlGoodsListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //구매가능, 품절 설정
    handleBuyYn_Click(event,list,buy_yn){
        list.buy_yn = buy_yn;
        if (buy_yn === "N") {
            list.quan = list.quan_restore
        }
        this.setState({ isOk: true });
        event.preventDefault();
    }
    //수량설정 Input 변경
    handleQuanAdd_Change(event,list,plus)
    {
      
        let Type = event.target.type;
        let Value = 0;
        let Quan = list.quan;
        let Totalprice = 0;
        const Buy_Yn = list.buy_yn;

        if (Buy_Yn === "N") {
            list.quan = list.quan_restore;
            this.setState({ Content: "품절시 수량은 변경할 수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Quan === 1 && plus < 0) {

            this.setState({ Content: "구매수량은 1보다 작을수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Quan >= 999) {
            this.setState({ Content: "구매수량은 1000보다 클수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Type === "text") {
            Value = event.target.value;
            if (Big3Common.Util.isNumber(Value) === false) {
                return false;
            }
            Quan = Value === "" ? 0 : parseInt(Value);
        }
        else {
            Quan = Quan + (plus);
        }
        Totalprice = (Quan === "" ? 0 : Quan * list.goods_price);
        list.quan = Quan;
        list.goods_price_tot = Totalprice;
        this.setState({ isOk: true });
        event.preventDefault();
    }
    //재고답변하기
    async handleSave_Click(event)
    {
        const QuanCount = this.state.GoodsList.filter(list => list.quan === null || list.quan === "" || list.quan === 0);
        const BuyCount=this.state.GoodsList.filter(list=>list.buy_yn===null ||list.buy_yn==="");
        if(QuanCount.length>0)
        {
            this.setState({ Content: "구매수량을 확인해 주세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        else if(BuyCount.length>0)
        {
            this.setState({ Content: "상품별 [가능] [품절]을 선택하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }

        try {
            //마스터 등록
            const StatusModel={
                Union_Uid:this.Union_Uid,
                Qstgrp_No:this.QstgrpNo,
                Qst_Status:"AN"
            }
            const Model={StatusModel:StatusModel,GoodsModel:this.state.GoodsList};
            let Data = await Big3Common.Post('api/Order/QuestionMgr/RegisterQstMgtStatusAN',Model,true);            
            if (Data.codeName === Big3Common.ResultCode.Success) {
               this.PageComplete=true;
               this.setState({ Content:Data.message});
               Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            else {
               this.setState({ Content:Data.message});
               Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("handleSave_Click: ", e)
        }
        
        event.preventDefault();
    }
    //채팅창 이동
    handleBack_Clik()
    {
        if(this.PageComplete===true)
        {
            this.props.RenderComponent("RtiQstDtl",
            {
                [this.CsName.Union_Uid]: this.Union_Uid,
                [this.CsName.QstgrpNo]: this.QstgrpNo,
                [this.CsName.Whole_Name]: Big3Common.Util.GetContentState(this.props.ContentState,this.CsName.Whole_Name,""),
                [this.CsName.SearchText]: Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchText, "")
            });
        }
       return false;
    }
    //헤더
    Masterrender()
    {   
        if(this.state.MasterData.length===0) return false;
        const MasterData=this.state.MasterData[0];
        return(
             <div className="order_shop_info_box stock_info">
                    <div className="Question_number">문의번호 : {MasterData.qstgrp_no}</div>
                    <div className="Question_number">문의날짜 : {MasterData.reg_dt}</div>
             </div>
        )
    }
    //상품 리스트
    Goodsrender()
    {
        if(this.state.GoodsList===0) return false;
        
        const GoodsList = Big3Common.Util.groupBy(this.state.GoodsList, list => list.goods_no);
        const GoodsListJson = [];
        for (const item of GoodsList.entries()) {
            GoodsListJson.push({
                "GoodsNo": item[0],
                "GoodsList": item[1],
            });
        }
        return(
             <>
             {
                 GoodsListJson.map((list,idx) =>
                    <div className="order_dtl_box" key={idx}>
                        <div className="order_goods_info">
                                <div className="order_goods_img">
                                     <GoodsPhoto
                                        className="order_goods_img_in"
                                        ImageSrc={list.GoodsList[0].img_220}
                                    />
                                </div>
                                <div className="order_txt">
                                    <div className="goods_title">{list.GoodsList[0].goods_nm}</div>
                                    <div className="goods_price">{Big3Common.Util.Money(list.GoodsList[0].goods_price)}원</div>
                                </div>
                        </div>
                        <div className="amount_box">
                        {
                            list.GoodsList.map((subList,sdx)=>
                                 <div className="amount_box_in" key={sdx}>
                                        <div className="product_name">
                                            {subList.crd_cd_nm}  /  {subList.size_nm}  ({Big3Common.Util.Money(subList.goods_price_tot)})
                                        </div>
                                        <div className="amount_check_box">
                                            <div className="number_check">
                                            <button type="button" onClick={(e) => { this.handleQuanAdd_Change(e, subList, -1) }}>-</button>
                                            <input type="text"
                                                className="form-control"
                                                value={subList.quan}
                                                maxLength="3"
                                                readOnly={subList.buy_yn === "N" ? true : false}
                                                onChange={(e) => { this.handleQuanAdd_Change(e, subList, 0) }}
                                                />
                                                <button type="button" onClick={(e)=>{this.handleQuanAdd_Change(e,subList,1)}} className="btn_2">+</button>
                                            </div>
                                            <div className="status_check">
                                                <div className={subList.buy_yn ==="Y" ? "status select" : "status"}  onClick={(e)=>{this.handleBuyYn_Click(e,subList,'Y')}}>가능</div>
                                                <div className={subList.buy_yn ==="N" ? "status select" : "status"} onClick={(e)=>{this.handleBuyYn_Click(e,subList,'N')}}>품절</div>
                                            </div>
                                        </div>
                                 </div>
                            )
                        }
                        </div>
                    </div>
                 )
             }
           </>
        )
    }
    render() {
        const Masterrender=this.Masterrender();
        const Goodsrender=this.Goodsrender();
        return (
            <div className="container_box2   d_padding  p_b_margin">
                {Masterrender}
                {Goodsrender}
               <div className="catagory_button_box catagory_button_box2">
                   {
                        this.QstStatus === "QA" ? <button type="button" onClick={(e) => { this.handleSave_Click(e) }} className="btn_v btn_v1">재고 답변하기</button> 
                       : ""
                   }
               </div>
                <Alert
                    id="MessageAlert"
                    title="재고답변"
                    content={this.state.Content}
                    AlertClick={this.handleBack_Clik}
                />
               
            </div>
        );
    }
}
